import { api } from './api';

export interface Trip {
  id: string; title: string; destination: string | null; description: string | null;
  departDate: string; returnDate: string; consentDeadline: string;
  costPaise: number; capacity: number; stage: string;
  leadStaffName: string | null; emergencyContact: string | null;
  granted: number; declined: number; pending: number; seatsLeft: number; acceptingConsent: boolean;
}

export interface TripConsent {
  id: string; tripId: string; studentId: string; studentName: string; classLabel: string | null;
  state: string; respondedByName: string | null; respondedAt: string | null;
  emergencyPhone: string | null; medicalNote: string | null; guardianNote: string | null;
  invoiceId: string | null; attended: boolean;
}

export const tripsApi = {
  list: (includePast = false) => api.get<Trip[]>(`/api/trips?includePast=${includePast}`),
  get: (id: string) => api.get<Trip>(`/api/trips/${id}`),
  create: (b: { institutionId: string; title: string; destination: string | null; description: string | null;
    departDate: string; returnDate: string; consentDeadline: string; costPaise: number;
    capacity: number; eligibleClassIds: string | null }) => api.post<Trip>('/api/trips', b),
  assignLead: (id: string, b: { userId: string; name: string; emergencyContact: string | null }) =>
    api.post<Trip>(`/api/trips/${id}/lead`, b),
  open: (id: string) => api.post<Trip>(`/api/trips/${id}/open`, {}),
  close: (id: string) => api.post<Trip>(`/api/trips/${id}/close`, {}),
  complete: (id: string) => api.post<Trip>(`/api/trips/${id}/complete`, {}),
  cancel: (id: string) => api.post<Trip>(`/api/trips/${id}/cancel`, {}),
  inviteClass: (id: string, academicClassId: string) =>
    api.post<{ invited: number }>(`/api/trips/${id}/invite-class`, { academicClassId }),
  roster: (id: string) => api.get<TripConsent[]>(`/api/trips/${id}/roster`),
  consents: (id: string) => api.get<TripConsent[]>(`/api/trips/${id}/consents`),
  markAttended: (tripId: string, consentId: string, attended: boolean) =>
    api.post<TripConsent>(`/api/trips/${tripId}/attendance/${consentId}`, { attended }),
  charge: (id: string, academicYear: string) =>
    api.post<{ charged: number; skipped: number }>(`/api/trips/${id}/charge`, { academicYear }),
};

export const portalTripsApi = {
  forStudent: (studentId: string) => api.get<TripConsent[]>(`/api/portal/trips/student/${studentId}`),
  respond: (tripId: string, b: { studentId: string; consent: boolean; emergencyPhone: string | null;
    medicalNote: string | null; note: string | null }) =>
    api.post<TripConsent>(`/api/portal/trips/${tripId}/respond`, b),
  withdraw: (tripId: string, studentId: string, note: string | null) =>
    api.post<TripConsent>(`/api/portal/trips/${tripId}/withdraw/${studentId}`, { note }),
};
